import { applyMiddleware, compose, createStore } from 'redux';
import rootReducer from '../reducers/index';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas/index';
import { routerMiddleware } from 'react-router-redux';
var createHistory = require('history').createHashHistory;

const history = createHistory ();
const routeMiddleware = routerMiddleware (history);
const sagaMiddleware = createSagaMiddleware ();

const middlewares = [sagaMiddleware, routeMiddleware];

export default function configureStore (initialState) {
  const store = createStore(rootReducer, initialState,
    compose (applyMiddleware (...middlewares)));

  sagaMiddleware.run (rootSaga);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept ('../reducers', () => {
      const nextRootReducer = require ('../reducers/index');
      store.replaceReducer (nextRootReducer);
    });
  }
  return store;
}
export { history };



// WEBPACK FOOTER //
// ./store/index.js